import { render, staticRenderFns } from "./account-verify-take-photo.vue?vue&type=template&id=05caa410&"
import script from "./account-verify-take-photo.vue?vue&type=script&lang=js&"
export * from "./account-verify-take-photo.vue?vue&type=script&lang=js&"
import style0 from "./account-verify-take-photo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports